import * as types from '../types'

/**
 * 收银台详情数据
 * @type {Object}
 */
const state = {
    data: {
        coupons:  {
            total: 0
        },
        order: {
            real_amount: 0.00
        }
    }
}

const getters = {

}

const mutations = {
    [types.INIT_CASHIER] (state, params) {
        state.data = params
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/cashier.js